import React from 'react';
import InquiryListComponent from '../../../components/admin/inquiry/InquiryListComponent';

const InquiryList: React.FC = () => {
  return <InquiryListComponent />;
};

export default InquiryList;
